<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card>
      <v-card-title primary-title> Pull-out post-dated check </v-card-title>
      <v-card-text>
        <div class="">
          <div>Reason of pull-out:</div>
          <!-- selections  -->
          <v-item-group>
            <v-container>
              <div class="md:flex justify-evenly w-full">
                <div
                  class="md:w-1/2 mr-4 my-4"
                  v-for="(item, n) in selection"
                  :key="n"
                  md="4"
                >
                  <v-item v-slot="{ active, toggle }">
                    <v-card
                      :color="active ? 'primary' : ''"
                      class="d-flex align-center"
                      height="50"
                      @click="toggle"
                    >
                      <v-scroll-y-transition>
                        <div
                          :class="active ? 'text-white' : 'text-gray-700'"
                          class="
                            text-2xl
                            md:text-sm
                            sm:text-sm
                            lg:text-md
                            px-4
                            py-4
                            align-align-top
                            flex
                            h-full
                            w-full
                          "
                        >
                          {{ item.title }}
                        </div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </div>
              </div>
            </v-container>
          </v-item-group>
          <!-- selections  -->

          <div class="w-full border border-gray-500 my-4">
            <textarea
              placeholder="Justification (Limit to 300 characters only)"
              class="px-4 py-2 w-full h-full"
            ></textarea>
          </div>
          <div>
            Any separate requests indicated in the ‘Justification’ will not be
            acknowledged for processing.
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title primary-title> Check/s to pull-out </v-card-title>
      <v-card-text>
        <table class="w-full">
          <tr>
            <th class="w-1/4">Check Date</th>
            <th class="w-1/4">Check Number</th>
            <th class="w-1/4">Amount</th>
            <th class="w-1/4">Bank and Branch</th>
          </tr>
          <tr>
            <td class="w-1/4 border border-gray-500 md:mr-1">
              <input class="w-full px-4 py-2" type="text" />
            </td>
            <td class="w-1/4 border border-gray-500 md:mr-1">
              <input class="w-full px-4 py-2" type="text" />
            </td>
            <td class="w-1/4 border border-gray-500 md:mr-1">
              <input class="w-full px-4 py-2" type="text" />
            </td>
            <td class="w-1/4 border border-gray-500">
              <input class="w-full px-4 py-2" type="text" />
            </td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
    <!-- <v-card class="my-1">
      <v-card-title primary-title> Upload Sample Computation </v-card-title>
      <v-card-text>
        <div>
          Upload your signed Sample Computation and/or the signed House Layout
          and Perspective of the property where you are requesting to transfer
          to. You may get the mentioned documents from your authorized
          Seller/Broker.
        </div>
        <div class="my-1 flex items-center">
          <div class="border border-gray-500 w-1/2">
            <input type="text" class="w-full px-4 py-2" />
          </div>
          <v-btn color="lightblue">Add attachment</v-btn>
        </div>
        <div class="my-1 flex items-center">
          <div class="border border-gray-500 w-1/2">
            <input type="text" class="w-full px-4 py-2" />
          </div>
          <v-btn color="lightblue">Add attachment</v-btn>
        </div>
        <div class="my-1 flex items-center">
          <div class="border border-gray-500 w-1/2">
            <input type="text" class="w-full px-4 py-2" />
          </div>
          <v-btn color="lightblue">Add attachment</v-btn>
        </div>

        <input type="text" />
        <input type="text" />
      </v-card-text>
    </v-card> -->

    <!-- reminder  -->
    <v-card class="my-1">
      <v-card-text>
        <div>
          <v-card-title primary-title> Proof of replacement </v-card-title>
          <div>
            If you have made a corresponding replacement, upload the proof of
            payment here (Provisional Receipt or transaction slip).
          </div>
          <div class="flex w-full">
            <div class="items-center w-3/4 border border-gray-700">
              <input
                label="Description"
                class="px-4 py-2 w-full"
                type="text"
                placeholder="Description"
              />
            </div>
            <v-btn class="ml-2 w-1/4" dark elevation="" color="blue"
              >Add Attachment</v-btn
            >
          </div>
          <div class="w-full flex justify-end">
            <v-btn small color="blue" dark>
              <v-icon> mdi-plus </v-icon> Add more
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <ul>
          <li>
            1. If you have already moved-in the subject property, you may only
            request to pull-out post-dated checks if there is a corresponding
            replacement (either cash or another check).
          </li>
          <li>
            2. You must give an advanced notice and submit your request at least
            15 working days prior the check date.
          </li>
          <li>
            3. Your request to pull-out a check is subject for Management
            approval.
          </li>
          <li>
            4. Moldex will not be liable for any penalties you may incur with
            the bank for bounced checks.
          </li>
          <li>
            5. Once submitted, you may see the status of your request on your
            Dashboard.
          </li>
        </ul>
      </v-card-text>
    </v-card>
    <AlertDialog
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <div class="my-2 w-full">
      <v-btn @click="submit" class="w-full" color="blue"> Submit Request</v-btn>
    </div>
  </div>
</template>

<script>
import AlertDialog from "../../common/AlertDialog.vue";
import BackButton from "@/common/BackButton.vue";
export default {
  data() {
    return {
      selection: [
        {
          title: "Closed Account",
          id: 1,
        },
        {
          title: "Altercation",
          id: 2,
        },
        {
          title: "Insufficient Fund",
          id: 3,
        },
        {
          title: "Replacement",
          id: 4,
        },
      ],
      penalties_to_waive: "",
      showAlert: false,
    };
  },
  components: {
    AlertDialog,
    BackButton,
  },
  methods: {
    submit() {
      this.showAlert = true;
    },
    back(n) {
      this.$router.push({ name: n });
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
};
</script>